/**
 * Chat Interface Component
 * 
 * Main chat interface wrapper for the Brand Consultant feature.
 * Combines MessageList and MessageInput with proper layout and state management.
 */

import { MessageList } from './MessageList';
import { MessageInput } from './MessageInput';
import { cn } from '@/lib/utils';
import { Message } from './types';

interface ChatInterfaceProps {
  messages: Message[];
  onSendMessage: (message: string) => Promise<boolean>;
  isLoading: boolean;
  hasAvailableCredits: boolean;
  messageCost: number;
  creditBalance: number;
  brand?: any; // Brand object from context
  className?: string;
}

export function ChatInterface({
  messages,
  onSendMessage,
  isLoading,
  hasAvailableCredits,
  messageCost,
  creditBalance,
  brand,
  className
}: ChatInterfaceProps) {
  return (
    <div className={cn("flex flex-col h-full", className)}>
      {/* Messages area */}
      <MessageList 
        messages={messages}
        isLoading={isLoading}
        className="flex-1"
      />

      {/* Input area */}
      <div className="border-t bg-background p-4">
        <MessageInput
          onSendMessage={onSendMessage}
          isLoading={isLoading}
          hasAvailableCredits={hasAvailableCredits}
          messageCost={messageCost}
          creditBalance={creditBalance}
          placeholder={
            brand 
              ? `Ask me anything about ${brand.brand_name}'s strategy, performance, or marketing insights...`
              : "Ask me anything about your brand strategy, content performance, or marketing insights..."
          }
        />
      </div>
    </div>
  );
}